import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose, branch, renderComponent } from 'recompose'

import UploadProgress from './UploadProgress'
import DropZoneContainer from './DropZoneContainer'
import UploadIconContainer from './UploadIconContainer'

import {
  PAGE
} from './constants'


const UploadPage = compose(
  branch(
    ({ page }) => page === PAGE.UPLOADING,
    renderComponent(UploadProgress),
    renderComponent(DropZoneContainer)
  ))(UploadIconContainer)

export default UploadPage